/**
 * Emergency Help usage counts (M35-T07, ADR-0064). amtc_admin only.
 * Aggregates of anonymous events: no one's details are behind any number.
 */
import { apiFetch } from './client'

export type UsageWindow = 7 | 30

export type KindCounts = {
  opened: number
  called_112: number
  viewed_hospital: number
  called_hospital: number
  got_directions: number
}

export type EmergencyHelpUsage = {
  days: UsageWindow
  since: string
  totals: KindCounts
  /** Every day of the window, oldest first, zero-filled. */
  by_day: Array<{ date: string; total: number; counts: KindCounts }>
  /** Hospitals with at least one view or call, most viewed first. */
  hospitals: Array<{
    slug: string
    name: string
    viewed: number
    called: number
  }>
}

export const emergencyHelpUsageKey = (days: UsageWindow) =>
  ['admin', 'emergency-help-usage', days] as const

export async function fetchEmergencyHelpUsage(
  token: string | null,
  days: UsageWindow,
): Promise<EmergencyHelpUsage> {
  const body = await apiFetch<{ data: EmergencyHelpUsage }>(
    `/api/v1/admin/emergency-help/usage?days=${days}`,
    { token },
  )
  return body.data
}
